import { Avatar, Typography } from "@material-ui/core"
import { Box } from "@material-ui/core/"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogContent from "@material-ui/core/DialogContent"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import Grid from "@material-ui/core/Grid"
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import { Link } from "gatsby"
import React, { Fragment } from "react"
import { FiX } from "react-icons/fi"
import { MdEmail, MdModeEdit } from "react-icons/md"
import { useDispatch, useSelector } from "react-redux"
import * as actionUsers from "../../store/actions/userActions"
import { getAvator, getCurrentUser } from "../../utils"
import ContainerStyle from "../GridContainer/GridContainer"
import UserBanner from "./images/bg-profile.jpg"
import UploadAvator from "./UploadAvator"

const useStyles = makeStyles(theme => ({
  profileMailBtn: {
    padding: ".275rem 1rem",
  },
  profileMailBtnIcon: {
    lineHeight: "0",
  },
}))
const useStylesCont = makeStyles(theme => ContainerStyle)
/*dialogs end*/
const styles = theme => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#066CC1",
    fontSize: "24px",
    cursor: "pointer",
  },
})
const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props
  return (
    <MuiDialogTitle disableTypography>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <i aria-label="close" className={classes.closeButton} onClick={onClose}>
          <FiX />
        </i>
      ) : null}
    </MuiDialogTitle>
  )
})
const DialogContent = withStyles(theme => ({}))(MuiDialogContent)
/*dialogs end*/
const UserProfileBanner = ({ editmode }) => {
  const editStatus = editmode ? true : false
  const { isLoading, error, message, uplaodAvatorFormOpen } = useSelector(
    state => ({
      isLoading: state.user.loading,
      error: state.user.error,
      message: state.user.message,
      uplaodAvatorFormOpen: state.user.avatorFormOpen,
    })
  )

  const dispatch = useDispatch()

  const AvatorUrl = getAvator()
  const theme = useTheme()
  const handleClickOpen = () => {
    dispatch(actionUsers.avatorFormOpen(true))
  }
  const handleClose = () => {
    dispatch(actionUsers.avatorFormOpen(false))
  }
  const { firstName, lastName, mail, designation } = getCurrentUser()
  const classes = useStylesCont()
  const styles = useStyles()

  return (
    <Fragment>
      <Grid container>
        <Grid item xs={12} className="pa-0">
          <Box component="div" className="profile-cover-wrap overlay-wrap">
            <Box
              component="div"
              className="profile-cover-img "
              style={{ backgroundImage: "url(" + UserBanner + ")" }}
            ></Box>
            <Box component="div" className="bg-overlay bg-trans-dark-60"></Box>
            <Box component="div" className=" profile-cover-content py-50">
              <Grid container className={classes.container}>
                <Grid item xs={12} className="uploadedImg">
                  {/* {editStatus && (
                    <Typography
                      variant="caption"
                      className="edit-icon rounded-circle"
                      onClick={handleClickOpen}
                    >
                      <MdModeEdit />
                    </Typography>
                  )} */}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box component="div" className="media align-items-center">
                    <Box component="div" className="media-img-wrap  d-flex">
                      <Box
                        component="div"
                        className="avatar uploadedImg rounded-circle"
                      >
                        <Avatar
                          alt="User"
                          src={AvatorUrl}
                          className="avatar-img rounded-circle"
                        />
                        {editStatus && (
                          <Typography
                            variant="caption"
                            className="edit-icon rounded-circle"
                            onClick={handleClickOpen}
                          >
                            <MdModeEdit />
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box component="div" className="media-body">
                      <Box
                        component="div"
                        className="text-white text-capitalize display-6 mb-5 font-weight-400"
                      >
                        {" "}
                        {firstName + " " + lastName}
                      </Box>
                      <Box component="div" className="font-14 text-white">
                        <Box component="span" className="mr-5">
                          {designation}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box component="div" className="button-list">
                    <Link
                      to="/"
                      className={
                        styles.profileMailBtn +
                        " " +
                        "btn bg-h-light-blue-1 btn-wth-icon icon-wthot-bg btn-rounded text-white"
                      }
                    >
                      <Box component="span" className="btn-text">
                        Email
                      </Box>
                      <Box
                        component="span"
                        className={
                          styles.profileMailBtnIcon + " " + "icon-label"
                        }
                      >
                        <i className="icon">
                          <MdEmail />
                        </i>
                      </Box>
                    </Link>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={uplaodAvatorFormOpen}
        PaperProps={{
          style: {
            minWidth: "300px",
          },
        }}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Upload Image
        </DialogTitle>
        <DialogContent dividers>
          <UploadAvator />
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}

export default UserProfileBanner
